<div class="full-page">
    <div class="d-flex justify-content-between">
        <div class="text-center w-100">
            <div class="connect">
                <span
                    ><strong
                        >{{ isEdit ? ('IRONSIDE.modify-favorite.EDIT_LIST' | translate) :
                        ('IRONSIDE.modify-favorite.CREATE_LIST' | translate )}}</strong
                    ></span
                >
            </div>
            <form [formGroup]="form">
                <div class="formulaire">
                    <div>
                        <mat-form-field
                            appearance="outline"
                            class="w-100"
                            style="border-color: #fbba00; outline-color: #fbba00"
                        >
                            <mat-label
                                >{{ 'IRONSIDE.modify-favorite.LIST_NAME' | translate }}</mat-label
                            >
                            <input
                                matInput
                                type="text"
                                [type]="'text'"
                                name="name"
                                [placeholder]="'IRONSIDE.modify-favorite.LIST_NAME' | translate"
                                formControlName="name"
                                autocomplete="off"
                                required
                            />
                        </mat-form-field>
                    </div>

                    <div style="margin-top: 3vh">
                        <button
                            type="submit"
                            class="btn"
                            style="
                                color: white;
                                background-color: #fbba00;
                                border-radius: 5px;
                                font-size: 15px;
                            "
                            [disabled]="form.invalid"
                            (click)="valider()"
                        >
                            {{ 'IRONSIDE.modify-favorite.VALIDATE' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <ng-container *ngIf="loading">
        <div class="secsion-loading">
            <mat-spinner [diameter]="30"></mat-spinner>
        </div>
    </ng-container>
</div>
